import { useTabThuocContext } from '../../context';
import ThongTinPhieu from './ThongTinPhieu';

const ThongTinPhieuWrapper = () => {
	const { donThuocInfo, setDonThuocInfo, setDanhSachDonThuoc } = useTabThuocContext();

	return <ThongTinPhieu
		thongTinPhieu={donThuocInfo}
		setThongTinPhieu={setDonThuocInfo}
		setDanhSachPhieu={setDanhSachDonThuoc}
	/>;
};

export default ThongTinPhieuWrapper;
